import * as React from "react";
import Location from "../../presentations/Location";

const LocationContainer = (props: any) => {

  const {data} = props;

  return (
    <div>
      <Location data={data}></Location>
    </div>
  );
};

export default LocationContainer;
